<template>
  <tr>
    <td>
      <v-simple-checkbox :value="isSelected" @click="select(!isSelected)" :ripple="false" />
    </td>
    <td><CardStudentName :student="item.student" /></td>
    <td>{{ item.student.dob | ddmmyyyy }}</td>
    <td>
      <v-chip
        :color="item.status === 'present' ? 'green' : item.status === 'absent' ? 'orange' : 'gray'"
        :text-color="item.status === 'none' ? 'black' : 'white'"
      >
        {{ item.status | getStatus }}</v-chip
      >
    </td>
    <td></td>
    <td>
      <div class="d-flex justify-end">
        <v-btn :outlined="status !== 'present'" class="mr-2" color="success" @click="() => changeStatus('present')"
          >Có mặt</v-btn
        >
        <v-btn :outlined="status !== 'absent'" color="warning" @click="() => changeStatus('absent')">Vắng mặt</v-btn>
      </div>
    </td>
    <td>
      <div v-show="status === 'present'">
        <v-btn :outlined="item.subStatus !== 'onTime'" color="success" class="mr-2" @click="() => updateItem('onTime')"
          >Đúng giờ</v-btn
        >
        <v-btn :outlined="item.subStatus !== 'lateTime'" color="warning" @click="() => updateItem('lateTime')"
          >Vào muộn</v-btn
        >
      </div>
      <div v-show="status === 'absent'">
        <v-btn
          :outlined="item.subStatus !== 'excused'"
          color="success"
          class="mr-2"
          @click="() => updateItem('excused')"
          >Có phép</v-btn
        >
        <v-btn :outlined="item.subStatus !== 'unexcused'" color="warning" @click="() => updateItem('unexcused')"
          >Không phép</v-btn
        >
      </div>
    </td>
  </tr>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapActions } from 'vuex'
import { getDataSubStatus, getStatusData } from './headers'
export default {
  components: { CardStudentName },
  props: { item: Object, expand: Function, isExpanded: Boolean, select: Function, isSelected: Boolean },
  data() {
    return { status: '' }
  },
  mounted() {
    this.status = this.item.status
  },
  methods: {
    ...mapActions({
      update: 'slotStudentAttendance/update',
    }),

    changeStatus(status) {
      if (status === this.status) return
      this.status = status
    },

    updateItem(subStatus) {
      if (subStatus === this.item.subStatus) return
      this.$dialog.confirm({
        title: 'Xác nhận điểm danh',
        text: this.getTextPopup(this.status, subStatus),
        okText: 'Xác nhận',
        cancelText: 'Huỷ',
        done: async () => {
          try {
            this.$loading.active = true
            await this.update({ id: this.item._id, status: this.status, subStatus })
            this.$emit('reset')
            this.$alert.success('Điểm danh thành công')
          } catch (e) {
            this.$alert.errors(e)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
    getTextPopup(status, subStatus) {
      const textStatus = this.getStatusData('', status)
      const textSubStatus = this.getDataSubStatus('', subStatus)
      const colorStatus = this.getStatusData('color', status)
      const colorSubStatus = this.getDataSubStatus('color', subStatus)
      return `<div>Xác nhận điểm danh với trạng thái <span style="font-weight: bold; ${colorStatus}">${textStatus}</span> và <span style="font-weight: bold;${colorSubStatus}">${textSubStatus}</span> cho học sinh này.</div>`
    },
    getDataSubStatus: getDataSubStatus,
    getStatusData: getStatusData,
  },
  filters: {
    getStatus(status) {
      switch (status) {
        case 'present':
          return 'Có mặt'
        case 'absent':
          return 'Vắng mặt'
        default:
          return 'Chưa điểm danh'
      }
    },
  },
  watch: {
    item: {
      handler(val) {
        this.status = val.status
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
